<template>
    <div class="card-body">
        <h5 class="card-title">{{ browser.caption }}</h5>
        <ol class="card-text">
            <li v-for="step in getSteps(browser.name)" :key="step">
                {{ getStepContent(browser.name, step) }}
            </li>
        </ol>
    </div>
</template>
<script>
export default {
  props: [
    'browser'
    ],
  data() {
    return {
        numberOfSteps:{
            chrome: 3,
            firefox: 3,
            safari: 3,
            iossafari: 4,
            edge: 3
            /*    edge: "Microsoft Edge",
            edge:3
            /* 
                opera: "Opera",
                ie: "Internet Explorer"*/
        }
    }
    },
    methods: {
        getStepContent(browser, step) {
            return this.$t(`location-enable-${browser}-step-${step}`);
        },
        getSteps(browser) {
            return Array.from({ length: this.numberOfSteps[browser] }, (_, index) => index + 1);
        },
    },

}
</script>
